import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import dashboardIcon from "../assets/ic_dashboard.svg";
import userListIcon from "../assets/ic_userlist.svg";
import devotionsIcon from "../assets/ic_product.svg";
import prayerGuidesIcon from "../assets/ic_video.svg";
import downloadIcon from "../assets/ic_change_password.svg";
import logoutIcon from "../assets/ic_logout.png";

const Sidebar = ({ sidebarOpen, onLogout, toggleSidebar }) => {
  const navigate = useNavigate();
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    message: "",
    onConfirm: null,
  });

  const menuItems = [
    { label: "Dashboard", icon: dashboardIcon, path: "/dashboard" },
    "divider",
    { label: "User List", icon: userListIcon, path: "/dashboard/userlist" },
    "divider",
    { label: "Chakra Videos", icon: prayerGuidesIcon, path: "/dashboard/video" },
    "divider",
    { label: "Products", icon: devotionsIcon, path: "/dashboard/product" },
    "divider",
    { label: "Orders", icon: devotionsIcon, path: "/dashboard/orders" },
    "divider",
    { label: "Change Password", icon: downloadIcon, path: "/dashboard/changepass" },
    "divider",
  ];

  const handleLogoutClick = () => {
    setConfirmDialog({
      open: true,
      message: "Are you sure you want to logout?",
      onConfirm: () => {
        onLogout();
        navigate("/login");
        setConfirmDialog({ open: false, message: "", onConfirm: null });
      },
    });
  };

  return (
    <>
      {/* Sidebar Container */}
      <div
        className={`fixed inset-y-0 left-0 z-30 w-56 bg-[#211436] text-white transform 
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
        transition-transform duration-300 ease-in-out 
        md:relative md:translate-x-0 md:flex md:flex-col`}
      >
        {/* Logo Section */}
        <div className="flex items-center justify-center h-24 border-b border-white">
          <div className="flex items-center">
            <img src={logo} alt="Logo" className="w-full h-[90px] object-contain mr-3" />
          </div>
        </div>

        {/* Menu Items */}
        <nav className="flex-1 overflow-y-auto">
          {menuItems.map((item, idx) =>
            item === "divider" ? (
              <div key={idx} className="border-t border-white/40" />
            ) : (
              <NavLink
                to={item.path}
                key={item.label}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-5 py-4 transition-colors ${isActive
                    ? "bg-white text-[#5832AD]"
                    : "text-white hover:bg-white/20"
                  }`
                }
                end={item.path === "/dashboard"}
                onClick={() => {
                  if (window.innerWidth < 768) toggleSidebar();
                }}
              >
                <img
                  src={item.icon}
                  alt={item.label}
                  className={`w-5 h-5 ${item.icon && "transition-colors"} ${window.location.pathname === item.path ? "filter invert" : ""
                    }`}
                />
                <span className="text-sm font-medium">{item.label}</span>
              </NavLink>
            )
          )}

          {/* Logout Button */}
          <button
            onClick={handleLogoutClick}
            className="flex items-center gap-3 px-5 py-4 text-white hover:bg-white/20 w-full focus:outline-none"
          >
            <img src={logoutIcon} alt="Logout" className="w-5 h-5" />
            <span className="text-sm font-medium">Logout</span>
          </button>
        </nav>

        {/* ✅ Full Vertical Divider on Right Edge */}
        <div className="absolute top-0 right-0 w-[1px] h-full bg-white/30 hidden md:block"></div>
      </div>

      {/* Overlay for Mobile */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black opacity-30 z-20 md:hidden"
          onClick={toggleSidebar}
        />
      )}

      {/* Confirmation Dialog */}
      {confirmDialog.open && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
            <h2 className="text-lg font-bold text-gray-800">Confirmation</h2>
            <p className="text-gray-600 mt-2">{confirmDialog.message}</p>
            <div className="mt-4 flex justify-end gap-3">
              <button
                onClick={() =>
                  setConfirmDialog({ open: false, message: "", onConfirm: null })
                }
                className="px-4 py-2 border rounded-md text-gray-700 hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={confirmDialog.onConfirm}
                className="px-4 py-2 bg-[#000000] text-white rounded-md hover:bg-gray-700"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
